import { z } from 'zod';

export const TalentTimezoneEditorSchema = z
  .object({
    TIMEZONE: z.string().uuid().nullable(),
  })
  .superRefine((values, ctx) => {
    if (!values.TIMEZONE) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['TIMEZONE'],
        message: 'Required',
      });
    }
  });

export type TalentTimezoneEditor = z.infer<typeof TalentTimezoneEditorSchema>;
